<template>
  <div>
    <usersearch @change="getKeywords"></usersearch>
    <!--<van-tabs v-if="unlists.length>0">
      <van-tab title="待审核">
        <div>
          <div class="adminhouse">
            <ul>
              <li v-for="(item,index) in unlists" :key="index">
                <div class="litop">
                  <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
                    <div class="top" v-if="item.stick"></div>
                    <img :src="item.thumbnail" />
                  </div>
                  <div class="info">
                    <h1 @click="$router.push('/ershoufang/view/'+item.id)">{{item.title}}</h1>

                    <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                    <p class="txt3">浏览量：{{item.clicks}}次</p>
                  </div>
                </div>
                <p class="shenhe">
                  <van-tag
                    size="medium"
                    type="warning"
                    text-color="#fff"
                    @click="del(item.id,index,'ershoufang')"
                  >删除</van-tag>
                  <span style="font-size:12px; float:right;color:#ff976a">审核中</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="blank"></div>-->
    <van-tabs v-model="active" @click="getData">
      <van-tab title="上架中">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="editTitle(item.id)">
                        {{item.title}}
                        <van-icon name="edit" />
                      </h1>

                      <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="txt3">浏览量：{{item.clicks}}次</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="del(item.id,index,'ershoufang')"
                    >删除</van-tag>
                    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="close(item.id,index,'ershoufang')"
                    >下架</van-tag>
                <!--    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="weituo(item.id,'ershoufang')"
                    >委托</van-tag> -->
                      
                        <van-tag size="medium" color="#f8f8f8" text-color="#555"
											@click="$router.push('/user/edit/ershoufang/'+item.id)">修改</van-tag>
                        <van-tag size="medium" type="warning" text-color="#fff"
                        	@click="$router.push('/user/sticky/'+item.id+'/ershoufang')">置顶</van-tag>
                        <van-tag type="warning" size="medium" text-color="#fff"
                        	@click="refresh(item.id,'ershoufang')">刷新</van-tag>
					<!-- <van-tag size="medium" type="warning" text-color="#fff"
						@click="$router.push('/user/jishou/'+item.id+'/ershoufang')">急售</van-tag>		 -->
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
      <van-tab title="已下架">
        <div>
          <div class="adminhouse">
            <ul>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :immediate-check="false"
              >
                <li v-for="(item,index) in lists" :key="index">
                  <div class="litop">
                    <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
                      <div class="top" v-if="item.stick"></div>
                      <img :src="item.thumbnail" />
                    </div>
                    <div class="info">
                      <h1 @click="$router.push('/ershoufang/view/'+item.id)">{{item.title}}</h1>

                      <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
                      <p class="txt3">浏览量：{{item.clicks}}次</p>
                    </div>
                  </div>
                  <p class="litopbtn">
                    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="del(item.id,index,'ershoufang')"
                    >删除</van-tag>
                    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="open(item.id,index,'ershoufang')"
                    >上架</van-tag>
                    <van-tag
                      size="medium"
                      color="#f8f8f8"
                      text-color="#555"
                      @click="weituo(item.id,'ershoufang')"
                    >委托</van-tag>
           
                  </p>
                </li>
              </van-list>
            </ul>
          </div>
        </div>
      </van-tab>
	<van-tab title="未支付">
	  <div>
	    <div class="adminhouse">
	      <ul>
	        <van-list
	          v-model="loading"
	          :finished="finished"
	          finished-text="没有更多了"
	          @load="onLoad"
	          :immediate-check="false"
	        >
	          <li v-for="(item,index) in lists" :key="index">
	            <div class="litop">
	              <div class="img" @click="$router.push('/ershoufang/view/'+item.id)">
	                <div class="top" v-if="item.stick"></div>
	                <img :src="item.thumbnail" />
	              </div>
	              <div class="info">
	                <h1 @click="$router.push('/ershoufang/view/'+item.id)">{{item.title}}</h1>
	
	                <p class="txt3">刷新时间：{{item.refreshtime_cn}}</p>
	                <p class="txt3">浏览量：{{item.clicks}}次</p>
	              </div>
	            </div>
	            <p class="litopbtn">
	              <van-tag
	                size="medium"
	                color="#f8f8f8"
	                text-color="#555"
	                @click="del(item.id,index,'ershoufang')"
	              >删除</van-tag>
	              <van-tag
	                size="medium"
	                color="#f8f8f8"
	                text-color="#555"
	                @click="zhifu(item.id,index,'ershoufang')"
	              >支付</van-tag> 
	     
	            </p>
	          </li>
	        </van-list>
	      </ul>
	    </div>
	  </div>
	</van-tab>	
    </van-tabs>
    <van-dialog v-model="showEditDia" title="修改标题" show-cancel-button :before-close="saveTitle">
      <van-field
        v-model="title"
        placeholder="请输入自定义标题"
        rows="2"
        autosize
        type="textarea"
        :maxlength="24"
        show-word-limit
        :border="true"
      />
    </van-dialog>

    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import Footbar from "../../commpents/footbar";
import Usersearch from "../../commpents/usersearch";
import {
  Toast,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Tag,
  List,
  Icon,
  Button,
  Dialog,
  Tab,
  Tabs,
  Field,
  CellGroup,
  Row,
  Col,
  Search
} from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Field.name]: Field,
    [Col.name]: Col,
    [Search.name]: Search,
    [Dialog.Component.name]: Dialog.Component,
    Usersearch,
    Footbar
  },

  data() {
    return {
      getInitUrl: root + "user/ershoufang",
      getRefreshUrl: root + "user/refresh",
      getStickyUrl: root + "user/sticky",
      getDelUrl: root + "user/del",
      getCloseUrl: root + "user/close",
      getOpenUrl: root + "user/open",
      getWeituoUrl: root + "user/weituo",
      saveTitleUrl: root + "user/title",
      value: 0,
      type: 1,
      page: 1,
      k: "",
      title: "",
      lists: [],
      unlists: [],
      total: 0,
      loading: false,
      finished: false,
      showEditDia: false,
      active: 0,
      editId: 0
    };
  },

  mounted() {
    this.init();
  },

  methods: {
	  zhifu(id, type){
		 this.$router.push("/post/sticky/" +id + "/ershoufang"); 
	  },
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type, k: self.k },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var lists = reponseData.data.lists;
          if (lists.length == 0) {
            self.finished = true;
          }
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
          self.unlists = reponseData.data.unlists;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getData(name, title) {
      this.page = 1;
      this.lists = [];
      this.loading = true;
      this.finished = false;

      if (this.active == 0) {
        this.type = "1";
      }
      if (this.active == 1) {
        this.type = "2";
      }
      if (this.active == 2) {
        this.type = "3";
      }
      if (this.active == 3) {
        this.type = "4";
      }
      this.init();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.page >= this.total) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        this.init();
      }, 500);
    },
    refresh(id, type) {
    	var self = this;
    	$.ajax({
    		url: self.getRefreshUrl,
    		timeout: 120000,
    		dataType: "json",
    		type: "get",
    		data: {
    			id: id,
    			type: type
    		},
    		headers: self.getRequestHeader(),
    		success: function(reponseData, status) {
    			self.$toast(reponseData.message);
    			if (reponseData.status == 0) {
    				self.$router.push("/user/refresh/" + id + "/ershoufang");
    			}
    		},
    		error: function() {
    			self.$toast("system error");
    		}
    	});
    },
    sticky(id, type) {
      var self = this;
      $.ajax({
        url: self.getStickyUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { id: id, type: type },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast(reponseData.message);
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    del(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "删除提示",
          message: "确定删除这个房源吗？删除后不可恢复了额",
          confirmButtonText: "我要删除",
          cancelButtonText: "不删除",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getDelUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    close(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "下架提示",
          message: "我确定下架该房源，下架房源将不在显示",
          confirmButtonText: "我要下架",
          cancelButtonText: "不下架",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getCloseUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              if (reponseData.status == 1) {
                self.$toast(reponseData.message);
                self.lists.splice(index, 1);
              } else {
                self.$dialog
                  .alert({
                    title: "温馨提示",
                    message: "个人发布展示房源数量3套，请删除或下架往期发布房源"
                  })
                  .then(() => {
                    // on close
                  });
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    open(id, index, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "上架提示",
          message: "我确定上架该房源，上架房源将持续展示",
          confirmButtonText: "我要上架",
          cancelButtonText: "不上架",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getOpenUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 1) {
                self.lists.splice(index, 1);
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getKeywords(value) {
      this.k = value;
      this.getData();
    },
    weituo(id, type) {
      var self = this;
      this.$dialog
        .confirm({
          title: "委托提示",
          message:
            "该房源信息提交后，将由石柱生活网负责房源维护、拟售客源的管理。",
          confirmButtonText: "我要委托",
          cancelButtonText: "不委托",
          confirmButtonColor: "#ee0a24"
        })
        .then(() => {
          $.ajax({
            url: self.getWeituoUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: id, type: type },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
            },
            error: function() {
              self.$toast("system error");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    editTitle(id) {
      this.showEditDia = true;
      this.editId = id;
      console.log(this.editId);
    },
    saveTitle(action, done) {
      var self = this;
      if (action == "cancel") {
        done();
      } else {
        if (this.title == "") {
          this.$toast("标题不能为空");
          done(false);
        } else {
          $.ajax({
            url: self.saveTitleUrl,
            timeout: 120000,
            dataType: "json",
            type: "get",
            data: { id: self.editId, title: self.title },
            headers: self.getRequestHeader(),
            success: function(reponseData, status) {
              self.$toast(reponseData.message);
              if (reponseData.status == 0) {
                done(false);
              } else {

                done();
                location.reload();
              }
            },
            error: function() {
              self.$toast("system error");
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-img img {
  width: 80%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-info h1 {
  font-size: 18px;
}
.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}
.user-tag {
  text-align: center;
  padding: 15px 0;
}
.user-tag img {
  width: 40px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
.shenhe {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 15px;
  border-top: #f8f8f8 1px solid;
  border-bottom: #f8f8f8 1px solid;
}
</style>>



